const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_Smtp":
      return { ...state, Smtp: payload };
    case "SAVE_NotificationPref":
      return { ...state, NotificationPref: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
